import { useEffect } from "react";

import { useSearchParams } from "react-router-dom";

import { apis, callApi } from "../../../../api";

export function GoogleAuthenticationSuccess() {
	const [searchParams] = useSearchParams();
	const code = searchParams.get("code");

	useEffect(() => {
		const saveCode = async (code: string) => {
			try {
				await callApi({
					method: "POST",
					url: apis.GOOGLE_SET_CODE,
					body: { code },
				});
				localStorage.setItem("google_status", "CONNECTED");
			} catch (error) {
			} finally {
				window.close();
			}
		};

		if (code) {
			saveCode(code);
		}
	}, [code]);

	return null;
}
